import { Components, createTheme } from '@mui/material/styles'

import components from './components'

const theme = createTheme({
  components: components as Components,
})

export default theme
